import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useState, useMemo, useEffect, useRef } from "preact/hooks"
import Checkbox from "./elements/Checkbox"
import ColorCheckbox from "./elements/ColorCheckbox"
import Icon from "./elements/Icon"

export default function Facet({ facet, activeFacet, handleFacetChange }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    // const [active, setActive] = useState(true);
    const facetRef = useRef(null);

    const open = useMemo(() => (
        handleFacetChange 
            ? activeFacet === facet.id 
            : active
    ), [ handleFacetChange, activeFacet, facet.id, active ]);

    const toggleFacet = (e) => {
        e.stopPropagation();
        toggleActive();
        if(handleFacetChange) { // desktop only 1 facet opened at a time
            handleFacetChange(facet.id)
        }
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (facetRef.current && 
                !facetRef.current.contains(event.target) && 
                open
            ) {
                if(handleFacetChange) {
                    handleFacetChange(null); // Close desktop version
                } else {
                    toggleActive(); // Close mobile version
                }
            }
        }

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [open, handleFacetChange, toggleActive]);

    return (
        <li ref={facetRef} class={`ns-sidebar-dropdown ${open ? "ns-active" : ""}`} aria-expanded={!!open}>
            <span
                class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                data-nosto-element="facet"
                onClick={toggleFacet}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${open ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <span class="ns-color-black ns-facet-name">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <Icon name="arrow" className="ns-absolute" />
            </span>
            <div class={`ns-sidebar-submenu ns-d-none ns-facet-${facet.name.toLowerCase()}`} id={`${facet.id}-sub-menu`}>
                <ul class="ns-list-unstyled ns-p-0 ns-m-0" role="menu">
                    {facet.data?.map(value => (
                        <li
                            key={value.value}
                            class="ns-d-flex ns-justify-content-between ns-align-items-center"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            {facet.name == 'Color' ?
                                 <ColorCheckbox
                                 value={value.value}
                                 selected={value.selected}
                                 onChange={e => {
                                     e.preventDefault()
                                     toggleProductFilter(facet.field, value.value, !value.selected)
                                     toggleFacet(e)
                                 }}
                                />
                                : 
                                <Checkbox
                                    value={value.value}
                                    selected={value.selected}
                                    onChange={e => {
                                        e.preventDefault()
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                        toggleFacet(e)
                                    }}
                                />
                            }
                            {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-background-grey-light ns-border-radius-3">
                                {value.count}
                            </span> */}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
